import { render, staticRenderFns } from "./CinemaForm.vue?vue&type=template&id=4c1fb360"
import script from "./CinemaForm.vue?vue&type=script&lang=js"
export * from "./CinemaForm.vue?vue&type=script&lang=js"
import style0 from "./CinemaForm.vue?vue&type=style&index=0&id=4c1fb360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports